import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { getBaseUrl } from './ApiContext';
import { startSession } from './session';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const baseUrl = getBaseUrl();

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            console.log(tokenResponse);

            const accessToken = tokenResponse.access_token;

            // Fetch the user's profile information from Google
            try {
                const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                const userData = await userInfoResponse.json();

                if (userInfoResponse.ok) {
                    if (!userData.email || !userData.email.toLowerCase().endsWith('@kyberknight.com')) {
                        console.error('Rejected login from non-team account:', userData.email);
                        alert('Kyber Drive is restricted to Kyber Knight Capital team accounts.');
                        return;
                    }

                    // The Google token has now done the one job it is kept
                    // for: proving who this is. Trade it for the backend's
                    // own session token, which lasts a day, so that coming
                    // back to the tab this afternoon does not mean picking
                    // the account again. If the exchange is unavailable this
                    // hands back the Google token and its hour, exactly as
                    // before.
                    const session = await startSession(
                        accessToken,
                        baseUrl,
                        tokenResponse.expires_in
                    );
                    login(session.token, userData, session.expiresIn);
                    navigate('/');

                    // Wake up the server in the background
                    fetch(`${baseUrl}/api/hello`)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Failed to wake up the server');
                            }
                            return response.json();
                        })
                        .then(data => console.log(data.message))
                        .catch(error => console.error('Error waking up the server:', error));
                } else {
                    console.error('Failed to fetch user info:', userData);
                }
            } catch (error) {
                console.error('Error fetching user info:', error);
            }
        },
        onError: (error) => console.log('Login Failed:', error),
        flow: 'implicit',
    });

    return (
        <div className="login-container">
            <div className="background-image hero-back"></div>
            <div className="background-image hero-front"></div>
            <div className="login-content">
                <button className="login-button" onClick={() => googleLogin()}>
                    SIGN IN WITH GOOGLE
                </button>
            </div>
        </div>
    );
}

export default Login;
